export default [
  'components-button-micro',
  'components-button-small',
  'components-button-medium',
  'components-button-large',
]
